export default "/images/not_found_error.svg?03cf1cc314ecb49208b5b7f6895ca383";